import React from "react";
import FullPageLoading from "commons/loading/FullPageLoading.component";

const Logout = () => {
    return (
        <FullPageLoading />
    );
};

export default Logout;